/**
 * A vendégjegy nem termel bevételt (#167) — a panel oldali párja a backend
 * `src/tickets/guest-revenue.ts` fájljának.
 *
 * **Miért kell a panelnek saját példány.** A Jegyek oldal négy összesítő
 * csempéje NEM a backend kimutatásából dolgozik: a lap maga összegzi a
 * lekért jegyek árát (`fetchAllTicketsStats`). A backend hat helyen már
 * kihagyja a vendéget a bevételből, ez a fájl a hetedik hely — enélkül a
 * szervező a Jegyek oldalon és az Analitikán KÉT KÜLÖNBÖZŐ bevételt lát
 * ugyanarra az eseményre. Élesben mérve (2026-09-16, 16 jegy, 2 vendég):
 * Jegyek 240 000 RSD, Analitika 210 000 RSD. Kategóriára szűrve még
 * beszédesebb volt: a Vendég szűrő 75 000 RSD „bevételt" írt öt olyan
 * jegyre, amelyikért senki nem fizetett.
 *
 * **Amit szándékosan NEM csinál:** a darabszámokat nem szűkíti. A vendég
 * valódi résztvevő, aki csak nem fizetett — az eladott jegy, a létszám és a
 * beléptetési arány továbbra is számolja. Ugyanez a kettősség a backendben.
 */
export function isRevenueBearing(ticket: { attendeeType?: string | null }): boolean {
  return ticket.attendeeType !== 'GUEST';
}
